module.exports = __webpack_public_path__ + "img/tradingproductShareCfds.ffefbae0.png";